module.exports = __webpack_public_path__ + "static/media/homeChildVacc.7ba6a889.svg";